import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import ChatWidget from '@/components/ChatWidget';
import ComplianceStrip from '@/components/ComplianceStrip';

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <ComplianceStrip />
      <main className="flex-1 pb-24 md:pb-0">
        <Outlet />
      </main>
      <PublicFooter />
      <ChatWidget />
    </div>
  );
}
